import React, { Component } from 'react';
import _ from 'lodash';

import { Grid, Typography } from '@material-ui/core';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';


import { MyPATCollapse, MyPATLink } from '../../common';

import ContentData from '../types/ContentData';
import contentService from '../services/contentService';

const styles = (theme: Theme) => createStyles({
	upperText: {
		fontSize: '13px',
		opacity: 0.7,
		marginBottom: '6px',
	},
	keyValueContainer: {
		'& *': {
			display: 'inline',
			marginRight: '4px',
			fontSize: '14px'
		}
	},
	link: {
		color: theme.palette.primary.main,
		cursor: "pointer"
	}
});

interface OtherRelatedContentProps extends WithStyles<typeof styles> {
	content: ContentData
}

interface OtherRelatedContentStates {
	usedIn: any,
	showFull: boolean,
}

class OtherRelatedContent extends Component<OtherRelatedContentProps, OtherRelatedContentStates>{

	constructor(props: OtherRelatedContentProps) {
		super(props);

		this.state = {
			usedIn: null,
			showFull: false
		}

		this.getTitle = this.getTitle.bind(this);
		this.toggleShow = this.toggleShow.bind(this);

	}

	componentWillReceiveProps(nextProps:any,nextState:any) {
		if (!this.state.usedIn && nextProps.content.content_Id) {
			contentService.usedIn(nextProps.content.content_Id).then(r => {
				this.setState({ usedIn: r })
			})
		}
	}

	getTitle() {
		const { usedIn } = this.state;
		let title = "This content also used in test or course";
		if (_.get(usedIn, 'tests', []).length == 0 && _.get(usedIn, 'courses', []).length == 0) {
			title = "This content is not yet used in test or course";
		}
		return title;
	}

	toggleShow() {
		let { showFull } = this.state;
		this.setState({ showFull: !showFull });
	}

	render() {
		const { classes } = this.props;
		const { usedIn, showFull } = this.state;
		const total = _.get(usedIn, 'tests', []).length + _.get(usedIn, 'courses', []).length;

		return (
			<>
			{/* <MyPATCollapse title="Other Related Content"> */}
				<Typography variant="subtitle2" className={classes.upperText}>{this.getTitle()}</Typography>
				{
					_.map(_.get(usedIn, 'tests', []), (t, i: number) => {

						if (i < 2 || showFull) {

							return (
								<div key={`name_${i}`} className={classes.keyValueContainer}>
									<Typography variant="body1">Test: </Typography>
									<Typography variant="body1">{_.get(t, 'name', "")}</Typography>
								</div>
							)
						}

						return "";
					})
				}
				{
					_.map(_.get(usedIn, 'courses', []), (c, i: number) => {

						if (i < 2 || showFull) {

							return (
								<div key={`name2_${i}`} className={classes.keyValueContainer}>
									<Typography variant="body1">Course: </Typography>
									<Typography variant="body1">{_.get(c, 'name', "")}</Typography>
								</div>
							)
						}

						return "";
					})
				}
				{
					total > 5 && (
						<div className={classes.keyValueContainer} style={{ textAlign: 'right' }}>
							<Typography className={classes.link} variant="caption" onClick={this.toggleShow}> { showFull ? 'See Less' : 'See More'  } </Typography>
						</div>
					)
				}
			{/* </MyPATCollapse> */}
			</>
		);

	}

}



// @ts-ignore
export default withStyles(styles)(OtherRelatedContent);

